// extracted by mini-css-extract-plugin
module.exports = {"field":"CardMoveStep_field__iR6Dp","text":"CardMoveStep_text__1jmap"};